import { Component, OnInit, Input } from '@angular/core';

import { InvestOutput } from '@classes/invest/invest-bbc/invest-output';

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
    @Input() dataBlocks: InvestOutput[];

    constructor() { }

    ngOnInit() {
    }

}
